import cn from "classnames";
import React from "react";
import { AlignmentOptions } from "components/pdfViewer/types";
import useFormFlow from "modules/forms/hooks/useFormFlow";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";

export type AddToWalletQrCodeBlockType = Omit<FormBlockType, "data"> & {
    data: {
        width: number;
        align: AlignmentOptions
    },
}

export default function AddToWalletQrCodeBlock(block: AddToWalletQrCodeBlockType) {
    const { contact } = useFormFlow();
    const { width, align } = block.data;
    const alignmentCn = cn(
        { "mr-auto": align == "left" },
        { "ml-auto": align == "right" },
        { "mx-auto": align == "center" }
    );
    const addToWalletUrl = contact?.add_to_wallet_url;
    const source = `https://api.qrserver.com/v1/create-qr-code/?size=500x500&margin=20&data=${addToWalletUrl}`;

    return (
        <img
            alt={"qr-code"}
            className={alignmentCn}
            src={source}
            style={{ width: width + "%" }}
        />
    );
}
